<template>
    <div style="margin:0 10px">
        <div class="card">
            <!-- search -->
            <div class="search d-flex a-center j-sb">
                <div class="d-flex a-center">
                    <div style="width:150px;margin-right:10px;">
                        <el-select v-model="query.sourceId" placeholder="源知识点" clearable filterable class="search-input">
                            <el-option
                                v-for="item in nodeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div style="width:150px;margin-right:10px;">
                        <el-select v-model="query.relationType" placeholder="关系类型" clearable class="search-input">
                            <el-option
                                v-for="item in relationTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <el-button class="search-button" @click="init"></el-button>
                    <el-button class="add-button" @click="showAddDialog"></el-button>
                </div>
                <div>
                    <el-button type="info" plain @click="$router.push({name:'knowledge_graph'})">
                        <i class="el-icon-back"></i> 返回列表
                    </el-button>
                </div>
            </div>

            <!-- handle -->
            <div class="handle"></div>

            <!-- table -->
            <div class="table" style="margin-top:20px;">
                <el-table
                    :data="tableData"
                    style="width: 100%;"
                    v-loading="loading"
                    element-loading-background="rgba(255,255,255, 0.6)"
                    :header-cell-style="{background:'#f8f8f9',color:'#606266',borderBottom:'1px solid #e8eaec',padding:'8px 0',fontWeight:'700'}"
                >
                    <el-table-column prop="sourceName" label="源知识点" align="center" min-width="150"></el-table-column>
                    <el-table-column prop="relationType" label="关系类型" align="center" width="120">
                        <template slot-scope="scope">
                            <el-tag :type="getRelationTagType(scope.row.relationType)">
                                {{ getRelationTypeName(scope.row.relationType) }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="targetName" label="目标知识点" align="center" min-width="150"></el-table-column>
                    <el-table-column prop="description" label="描述" align="center" min-width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" align="center" width="170">
                        <template slot-scope="scope">
                            {{ formatTime(scope.row.createTime) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="操作" align="center" width="100">
                        <template slot-scope="scope">
                            <el-popconfirm
                                title="是否确定删除？"
                                @confirm="handleDel(scope.row)"
                            >
                                <el-button type="text" slot="reference" size="small" class="delete-action">删除</el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- 添加关系对话框 -->
        <el-dialog title="添加关系" :visible.sync="dialogVisible" width="500px">
            <el-form :model="relationForm" :rules="relationRules" ref="relationForm" label-width="100px">
                <el-form-item label="源知识点" prop="sourceId">
                    <el-select v-model="relationForm.sourceId" placeholder="请选择源知识点" filterable style="width: 100%;">
                        <el-option
                            v-for="item in nodeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="关系类型" prop="relationType">
                    <el-select v-model="relationForm.relationType" placeholder="请选择关系类型" style="width: 100%;">
                        <el-option
                            v-for="item in relationTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="目标知识点" prop="targetId">
                    <el-select v-model="relationForm.targetId" placeholder="请选择目标知识点" filterable style="width: 100%;">
                        <el-option
                            v-for="item in nodeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            :disabled="item.id === relationForm.sourceId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="描述" prop="description">
                    <el-input type="textarea" rows="3" v-model="relationForm.description" placeholder="请输入描述（可选）"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitRelation">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { relationList, relationSave, relationDel, list } from '@/request/api/knowledge_graph.js'
import moment from 'moment'

export default {
    data() {
        return {
            tableData: [],
            query: { courseId: '' },
            loading: false,
            nodeList: [],
            dialogVisible: false,
            relationForm: {
                sourceId: '',
                targetId: '',
                relationType: '',
                description: ''
            },
            relationRules: {
                sourceId: [
                    { required: true, message: '请选择源知识点', trigger: 'change' }
                ],
                targetId: [
                    { required: true, message: '请选择目标知识点', trigger: 'change' }
                ],
                relationType: [
                    { required: true, message: '请选择关系类型', trigger: 'change' }
                ]
            },
            relationTypeList: [
                { value: 'prerequisite', label: '前置知识' },
                { value: 'successor', label: '后继知识' },
                { value: 'related', label: '相关知识' },
                { value: 'contains', label: '包含' },
                { value: 'belongs_to', label: '属于' }
            ]
        }
    },
    created() {
        this.loadNodeList()
        this.init()
    },
    methods: {
        // 加载知识点列表
        loadNodeList() {
            list({}).then(res => {
                if (res.code == 0) {
                    this.nodeList = res.data || []
                }
            })
        },
        init() {
            this.loading = true
            relationList(this.query).then(res => {
                if (res.code == 0) {
                    this.tableData = res.data || []
                }
            }).finally(() => {
                this.loading = false
            })
        },
        handleDel(data) {
            relationDel(data.id).then(res => {
                if (res.code != 0) return this.$notify.error({ title: '错误', message: res.msg })
                this.init()
                this.$notify({ title: '成功', message: '删除成功', type: 'success' })
            })
        },
        showAddDialog() {
            this.relationForm = {
                sourceId: '',
                targetId: '',
                relationType: '',
                description: ''
            }
            this.dialogVisible = true
        },
        submitRelation() {
            this.$refs['relationForm'].validate((valid) => {
                if (valid) {
                    relationSave(this.relationForm).then(res => {
                        if (res.code != 0) return this.$notify.error({ title: '错误', message: res.msg })
                        this.$notify({ title: '成功', message: '添加成功', type: 'success' })
                        this.dialogVisible = false
                        this.init()
                    })
                }
            })
        },
        getRelationTypeName(type) {
            const item = this.relationTypeList.find(r => r.value === type)
            return item ? item.label : type
        },
        getRelationTagType(type) {
            const typeMap = {
                'prerequisite': 'warning',
                'successor': 'success',
                'related': 'info',
                'contains': 'primary',
                'belongs_to': ''
            }
            return typeMap[type] || ''
        },
        formatTime(time) {
            if (!time) return '-'
            return moment(time).format('YYYY-MM-DD HH:mm')
        }
    }
}
</script>

<style scoped lang="less">
.delete-action {
    color: #f56c6c;
    &:hover {
        color: #f78989;
    }
}
</style>
